$(function () {
    let $tracking = $('.gatracking');

    if ($tracking.length)
    {
        let data = JSON.parse($('[data-gadds]').attr('data-gadds'));
    
            if (data)
            {
                gtag('event', 
                    'conversion', 
                    { 
                        'send_to': 'AW-866511646/x4uZCPX_69waEJ7Wl50D', 
                        'value': data.value,
                        'currency': data.currency,
                    }
                ); 
                
            }

    }
});